export default "__VITE_ASSET__CVRb1WPO__"